export default __webpack_public_path__ + "img/bFcwKmJd.a3542450.svg";